@if (isAuthChecked) {
  @if (isLoginRoute) {
    <router-outlet></router-outlet>
  } @else {
    <div class="app-container">
      @if (showOverlaySpinner) {
        <app-overlay-spinner />
      }
      <div class="sidebar no-print">
        <app-side-nav></app-side-nav>
      </div>

      <div class="app-content">
        <div class="header no-print">
          <app-header [userName]="userName"></app-header>
        </div>

        <main class="main-content">
          <app-comments-section />
          <app-notification-section />
          <div class="content">
            <app-message-toast></app-message-toast>
            <div class="router">
              @if (showErrorPage) {
                <div class="error-page">
                  <app-error-page [statusCode]="statusCode" />
                </div>
              } @else {
                <router-outlet></router-outlet>
              }
            </div>
          </div>
        </main>
      </div>
    </div>
  }
}
